import TRTC from 'trtc-sdk-v5'
import { logPost, newSaveBehavior } from '../../../assets/api/index'
import uaParserJs from 'ua-parser-js'
const uaParser = uaParserJs()
const { browser } = uaParser
export default (streamObj, startLocal, err) => {
  let name = startLocal === 'startLocalVideo' ? '摄像头' : startLocal === 'startLocalAudio' ? '麦克风' : startLocal === 'startScreenShare' ? '共享屏幕' : '摄像头和麦克风'
  let type = startLocal === 'startLocalVideo' ? 'video' : startLocal === 'startLocalAudio' ? 'audio' : startLocal === 'startScreenShare' ? 'screen' : 'videoAndAudio'
  let result = {
    tips: '',
    log: '',
    code: 0,
    transactionDesc: ''
  }
  console.log('aaaaaaaaaa', streamObj, startLocal, err, err.code)
  // console.log('aaaaaaaaa', startLocal, err, err.code, err.extraCode, String(err).indexOf('no camera detected') > -1)
  if (err && err.code && err.code === TRTC.ERROR_CODE.INVALID_PARAMETER) {
    // 调用接口时传入了不满足api要求的参数
    result = {
      noCameraTips: false,
      type,
      tips: type === 'video' ? 'bloomTest001251' : type === 'audio' ? 'bloomTest001252' : 'bloomTest00125',
      log: '调用接口时传入了不满足api要求的参数',
      code: 5000,
      transactionDesc: `未知原因异常，建议关闭该监考设置`
    }
  } else if (err && err.code && err.code === TRTC.ERROR_CODE.INVALID_OPERATION) {
    // 调用接口时，不满足 API 的前提要求。
    result = {
      noCameraTips: false,
      type,
      tips: type === 'video' ? 'bloomTest001251' : type === 'audio' ? 'bloomTest001252' : 'bloomTest00125',
      log: '调用接口时，不满足 API 的前提要求',
      code: 5100,
      transactionDesc: `未知原因异常，建议关闭该监考设置`
    }
  } else if (err && err.code && err.code === TRTC.ERROR_CODE.OPERATION_FAILED) {
    // 在满足 API 调用要求的情况下，SDK 经过多次重试仍然无法解决的异常，通常是由于浏览器、网络的问题造成。
    console.log(err, err.code, err.extraCode)
    if (String(err).indexOf('publish timeout') > -1) {
      result = {
        noCameraTips: true,
        type,
        tips: 'bloomTest00117',
        log: '本地流发布失败 -- 网络原因 推流超时',
        code: 5500,
        transactionDesc: `网络原因 推流超时`
      }
    } else if (String(err).indexOf('getTracks') > -1) {
      result = {
        noCameraTips: true,
        type,
        tips: 'bloomTest00123',
        log: '本地流发布失败 -- 使用了safari浏览器',
        code: 5500,
        transactionDesc: `使用了safari浏览器`
      }
    } else if (String(err).indexOf('Failed to join room') > -1) {
      result = {
        noCameraTips: true,
        type,
        tips: '',
        log: '加入TRTC房间失败（学生已通过，仅后台无画面，无需关闭监考设置）',
        code: 5500,
        transactionDesc: `加入TRTC房间失败（学生已通过，仅后台无画面，无需关闭监考设置）`
      }
    } else {
      result = {
        noCameraTips: true,
        type,
        tips: '',
        log: '推流失败（学生已通过，仅后台无画面，无需关闭监考设置）',
        code: 5500,
        transactionDesc: `推流失败（学生已通过，仅后台无画面，无需关闭监考设置）`
      }
    }
  } else if (err && err.code && err.code === TRTC.ERROR_CODE.OPERATION_ABORT) {
    // 中止 API 执行时抛出该错误码。在不满足 API 生命周期的调用或重复调用时 API 会中止执行，避免无意义的操作。
    result = {
      noCameraTips: false,
      type,
      tips: type === 'video' ? 'bloomTest001251' : type === 'audio' ? 'bloomTest001252' : 'bloomTest00125',
      log: '由于某些未知原因导致设备无法被使用',
      code: 5307,
      transactionDesc: `未知原因异常，建议关闭该监考设置`
    }
  } else if (err && err.code && err.code === TRTC.ERROR_CODE.ENV_NOT_SUPPORTED) {
    // 当前环境不支持该功能，表明当前浏览器不支持调用对应 API
    result = {
      noCameraTips: false,
      type,
      code: 5200,
      log: `当前浏览器不支持${type === 'screen' ? '屏幕分享' : name + '服务'}(${browser.name} ${browser.version})`,
      tips: type === 'screen' ? 'shareScreen.cannotShare' : 'bloomTest00121'
    }
  } else if (err && err.code && err.code === TRTC.ERROR_CODE.DEVICE_ERROR) {
    /* 获取设备或者采集音视频出现异常。这些接口出现异常时会抛出该错误码
    引导用户检查设备是否有摄像头及麦克风、系统是否给浏览器授权以及浏览器是否给页面授权。
    建议增加进房前的设备检测流程，确认麦克风和摄像头是否存在，并且能正常采集，再进行下一步通话操作。
    通常经过设备检查后都能避免该异常。实现方式请参考: 通话前环境与设备检测。 */
    switch (err.extraCode) {
      case 5301:
        // 无法找到你的媒体设备
        result = {
          noCameraTips: false,
          transactionDesc: `无法找到您的${name}，请确认已接入${name}或${name}驱动完好`,
          log: '找不到满足请求参数的媒体设备类型（包括：音频、视频、屏幕分享）。例如：PC 没有摄像头',
          tips: type === 'video' ? 'bloomTest001251' : type === 'audio' ? 'bloomTest001252' : 'bloomTest00125',
          code: 5301
        }
        break
      case 5302:
        // 系统拒绝了
        if (err.message.includes('Permission denied by system')) {
          result = {
            noCameraTips: true,
            type,
            code: 5302.1,
            log: `系统未开启${name}权限`,
            tips: type === 'video' ? 'bloomTest00149' : type === 'audio' ? 'bloomTest00189' : 'bloomTest00150'
          }
        } else {
          result = {
            noCameraTips: true,
            type,
            tips: type === 'video' ? 'bloomTest00149' : type === 'audio' ? 'bloomTest00189' : 'bloomTest00150',
            log: `${name}异常或者用户手动关闭了浏览器的采集权限导致`,
            code: 5302,
            transactionDesc: name === '共享屏幕' ? '拒绝/取消屏幕分享' : `未打开${name}权限`
          }
        }
        break
      case 5303:
        if (String(err).indexOf('Permission denied') > -1) {
          result = {
            noCameraTips: true,
            type,
            code: 5302.1,
            log: `系统未开启${name}权限`,
            tips: type === 'video' ? 'bloomTest00149' : type === 'audio' ? 'bloomTest00189' : 'bloomTest00150'
          }
        } else {
          result = {
            noCameraTips: false,
            type,
            tips: 'bloomTest00118',
            log: '尽管用户已经授权使用相应的设备，但是由于操作系统上某个硬件、浏览器或者网页层面发生的错误或者其他应用占用了设备导致设备无法被浏览器访问',
            code: 5303,
            transactionDesc: `${name}被占用`
          }
        }
        break
      case 5307:
        result = {
          noCameraTips: false,
          type,
          tips: 'bloomTest00125',
          log: '由于某些未知原因导致设备无法被使用',
          code: 5307,
          transactionDesc: `未知原因异常，建议关闭该监考设置`
        }
        break
      case 5308:  // 摄像头
      case 5309:  // 麦克风
        if (String(err).indexOf('Permission denied') > -1) {
          result = {
            noCameraTips: true,
            type: err.extraCode === 5308 ? 'video' : err.extraCode === 5309 ? 'audio' : 'audioAndVideo',
            tips: err.extraCode === 5308 ? 'bloomTest00149' : err.extraCode === 5309 ? 'bloomTest00189' : 'bloomTest00150',
            log: `${err.extraCode === 5308 ? '摄像头' : err.extraCode === 5309 ? '麦克风' : '摄像头或麦克风'}异常或者用户手动关闭了浏览器的采集权限导致`,
            code: 5302,
            transactionDesc: name === '共享屏幕' ? '拒绝/取消屏幕分享' : `未打开${name}权限`
          }
        } else {
          result = {
            noCameraTips: false,
            type: err.extraCode === 5308 ? 'video' : err.extraCode === 5309 ? 'audio' : 'audioAndVideo',
            tips: err.extraCode === 5309 ? 'bloomTest001252' : 'bloomTest001251',
            log: `${err.extraCode === 5309 ? '麦克风' : '摄像头'}异常或者用户手动关闭了浏览器的采集权限导致`,
            code: err.extraCode,
            transactionDesc: `${err.extraCode === 5309 ? '麦克风' : '摄像头'}连接后中途损坏或被拔出`
          }
        }
        break
      default:
        if (String(err).indexOf('no microphone detected') > -1) {
          result = {
            noCameraTips: false,
            type: 'audio',
            tips: 'bloomTest001252',
            log: '摄像头未插入或损坏',
            code: 5307,
            transactionDesc: `摄像头未插入或损坏`
          }
        } else if (String(err).indexOf('no camera detected') > -1) {
          result = {
            noCameraTips: false,
            type: 'audio',
            tips: 'bloomTest001251',
            log: '麦克风未插入或损坏',
            code: 5307,
            transactionDesc: `麦克风未插入或损坏`
          }
        } else {
          result = {
            noCameraTips: false,
            type,
            tips: type === 'video' ? 'bloomTest001251' : type === 'audio' ? 'bloomTest001252' : 'bloomTest00125',
            log: '由于某些未知原因导致设备无法被使用',
            code: 5307,
            transactionDesc: `未知原因异常，建议关闭该监考设置`
          }
        }

        break
    }
  } else if (err && err.code && err.code === TRTC.ERROR_CODE.SERVER_ERROR) {
    // 收到服务端返回的异常数据时抛出该错误码
    result = {
      noCameraTips: true,
      type,
      tips: type === 'video' ? 'bloomTest001251' : type === 'audio' ? 'bloomTest001252' : 'bloomTest00125',
      log: '收到服务端返回的异常数据时抛出该错误码',
      code: 5400,
      transactionDesc: `收到服务端返回的异常数据时抛出该错误码`
    }
  } else if (err && err.code && err.code === TRTC.ERROR_CODE.UNKNOWN_ERROR) {
    // 未知错误或者未被定义的错误
    result = {
      noCameraTips: false,
      type,
      tips: type === 'video' ? 'bloomTest001251' : type === 'audio' ? 'bloomTest001252' : 'bloomTest00125',
      log: '未知错误或者未被定义的错误',
      code: 5307,
      transactionDesc: `未知原因异常，建议关闭该监考设置`
    }
  } else {
    if (String(err).indexOf('Permission denied') > -1) {
      result = {
        noCameraTips: true,
        type,
        code: 5302.1,
        log: `系统未开启${name}权限`,
        tips: type === 'video' ? 'bloomTest00149' : type === 'audio' ? 'bloomTest00189' : 'bloomTest00150'
      }
    } else {
      // 排除所有原因后的未知原因错误
      result = {
        noCameraTips: false,
        type,
        tips: type === 'video' ? 'bloomTest001251' : type === 'audio' ? 'bloomTest001252' : 'bloomTest00125',
        log: '排除所有原因后的未知原因错误',
        code: 5307,
        transactionDesc: `未知原因异常，建议关闭该监考设置`
      }
    }
  }
  // 确保考试id存在且当前不在设备调试页
  if (location.href.toUpperCase().indexOf('bloomEquipment'.toUpperCase()) < 0 && streamObj.transactionId) {
    if (result.transactionDesc) newSaveBehavior({ transactionType: result.type === 'screen' ? 29 : 9, transactionId: streamObj.transactionId, transactionDesc: result.transactionDesc })
    // 摄像头正常不上报
    let userData = ''
    if (localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData'))) {
      userData = JSON.parse(localStorage.getItem('userData'))
      if (userData.data && JSON.parse(userData.data)) userData = JSON.parse(userData.data)
    }
    logPost({ a: result.code, c: result.log, r: '/', e: err, uid: userData.userId, examId: streamObj.transactionId, ua: navigator.userAgent })
  }
  return result
}



// WEBPACK FOOTER //
// ./src/components/bloom-proctor/public/trtcV5errorCode.js